/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_VersionsInputs */

const cs_documents_versions = /** @type {(inputs: Documents_VersionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verze`)
};

const en_documents_versions = /** @type {(inputs: Documents_VersionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versions`)
};

/**
* | output |
* | --- |
* | "Versions" |
*
* @param {Documents_VersionsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_versions = /** @type {((inputs?: Documents_VersionsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_VersionsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_versions(inputs)
	return cs_documents_versions(inputs)
});